export default __webpack_public_path__ + "static/media/product-arrow.b83c3eb7.svg";